import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JobSettingsValidationFormatterService {
  stringify(value: undefined | unknown, properties: string[] = []): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'object') {
      const objectValue = value as Record<string, unknown>;
      value =
        properties.length > 0
          ? properties.reduce((acc, property) => {
              acc[property] = objectValue[property];
              return acc;
            }, {} as typeof objectValue)
          : value;
    }

    return JSON.stringify(value, null, 2);
  }

  sanitizeCredentials(credentials: string): string {
    if (credentials === '') {
      return credentials;
    }
    return credentials.replaceAll(/(\r)?(\n)/g, '').trim();
  }
}
